import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const Services = () => {
  const { t, i18n } = useTranslation();
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await axios.get('https://hasanhaji.com/api/services');
        setServices(res.data.data.services);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching services:', err);
        setError('حدث خطأ أثناء تحميل الخدمات. الرجاء المحاولة مرة أخرى.');
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  return (
    <div className="container py-5">
      <h2 className="section-title">{t('home.services.title')}</h2>

      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      {loading ? (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="row">
          {services.map((service) => (
            <div className="col-md-4 mb-4" key={service.id}>
              <div className="service-card">
                <img src={service.icon} alt={i18n.language === 'ar' ? service.name : (service.nameEn || service.name)} className="service-icon-img mb-3" style={{ height: '60px', objectFit: 'contain' }} />
                <h3>{i18n.language === 'ar' ? service.name : (service.nameEn || service.name)}</h3>
                <p>{service.description}</p>
                {service.price > 0 && (
                  <div className="service-price">
                    <span>{service.price} د.ب</span>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Services;
